import { Divider, MoiaCard } from '@backoffice-frontend/patterns'
import { Heading, Text } from '@moia-dev/pace-web'
import type { PropsWithChildren } from 'react'

type ActionCardProps = {
  headline: string
  instructions?: string
}

export const ActionCard = ({
  children,
  headline,
  instructions,
}: PropsWithChildren<ActionCardProps>) => {
  return (
    <MoiaCard
      highlight="disabled"
      strongHighlight
      compact
      css={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0px 4px 6px -1px rgba(0, 12, 21, 0.12), 0px 0px 4px -1px rgba(0, 12, 21, 0.08)`,
      }}
    >
      <div
        css={theme => ({
          display: 'flex',
          padding: theme.space.Space4,
          flexDirection: 'column',
          gap: theme.spacing(1),
        })}
      >
        <Heading size="lg">{headline}</Heading>
        {instructions && (
          <Text size="lg" color="reduced">
            {instructions}
          </Text>
        )}
      </div>

      <Divider />

      <div css={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        {children}
      </div>
    </MoiaCard>
  )
}
